<template>
  <OrderPackingDetail label="Susulan Penjualan" :index-path="indexPath" />
</template>

<script>
import OrderPackingDetail from '../../../../components/order/OrderPackingDetail.vue';

export default {
  components: { OrderPackingDetail },
  props: {
    indexPath: String
  }
}
</script>